import { render, staticRenderFns } from "./FabricUpdate.vue?vue&type=template&id=279dd1de&scoped=true"
import script from "./FabricUpdate.vue?vue&type=script&lang=js"
export * from "./FabricUpdate.vue?vue&type=script&lang=js"
import style0 from "./FabricUpdate.vue?vue&type=style&index=0&id=279dd1de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279dd1de",
  null
  
)

export default component.exports